import MojitoCore from 'mojito/core';
import PrebuiltBetBuilderClassic from './classic/index.js';
import PrebuiltBetBuilderAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

export default UIViewFamily('PrebuiltBetBuilder', {
    classic: PrebuiltBetBuilderClassic,
    avantgarde: PrebuiltBetBuilderAvantgarde,
});
